import { stringify } from 'query-string';
import { apiCreate, apiGetList, apiGetOne } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_SHARE = 'API_CREATE_PROFFIT_SEARCH_SHARE';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE = 'API_CREATE_PROFFIT_SEARCH_SHARE';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_SUCCESS';
export const API_GET_ONE_PROFFIT_SEARCH_SHARE = 'API_GET_ONE_PROFFIT_SEARCH_SHARE';
export const API_GET_ONE_PROFFIT_SEARCH_SHARE_SUCCESS = 'API_GET_ONE_PROFFIT_SEARCH_SHARE_SUCCESS';
export const API_GET_ONE_PROFFIT_SEARCH_SHARE_STATUS = 'API_GET_ONE_PROFFIT_SEARCH_SHARE_STATUS';
export const API_UPDATE_PROFFIT_SEARCH_SHARE_BLOCK = 'API_UPDATE_PROFFIT_SEARCH_SHARE_BLOCK';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_MEMBERS = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_MEMBERS';
/**
 * 共有履歴の取得
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchShare = (data, meta) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SHARE, '/proffit_search/slide/share', data, Object.assign({}, meta));
/**
 * 共有対象のメールアドレスチェック
 * @param params
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneProffitSearchShareStatus = (params, meta) => apiGetOne(API_GET_ONE_PROFFIT_SEARCH_SHARE_STATUS, `/proffit_search/slide/share_status?${stringify(params)}`, params, meta || {});
/**
 * 共有履歴詳細の取得
 * @param id
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneProffitSearchShare = (id, meta) => apiGetOne(API_GET_ONE_PROFFIT_SEARCH_SHARE, `/proffit_search/slide/share/${id}`, Object.assign({ id }, (meta || {})));
/**
 * 共有の実行
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchShare = (data, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_SHARE, '/proffit_search/slide/share', data, Object.assign({}, meta));
/**
 * ブロックの更新
 * @param uuid
 * @param userId
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateProffitSearchBlock = (uuid, userId, data, meta) => apiCreate(API_UPDATE_PROFFIT_SEARCH_SHARE_BLOCK, `/proffit_search/slide/share_slide/${uuid}/${userId}/block`, data, Object.assign({}, meta));
/**
 * 共有可能なメンバー一覧の取得
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchShareMembers = (data, meta) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SHARE_MEMBERS, '/proffit_search/slide/share_members', data, Object.assign({}, meta));
